// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"c_-z","upvote":"d_-z","downvote":"e_-z","numVotes":"f_-z","votesDescription":"g_-z","report":"h_-z","voted":"i_-z","answerVoteBox":"j_-z","justReported":"k_-z"};